import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/constants/query-keys'
import { getAuditLog } from '../services/audit.service'

/**
 * Timeline de auditoría de una entidad (bitácora central). Lo usa el historial del portal
 * (`entityType='portal_form_request'`) y, a futuro, cualquier feed por entidad de la plataforma.
 */
export function useAuditLogQuery(entityType: string, entityId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.audit.byEntity(entityType, entityId ?? ''),
    queryFn: async () => await getAuditLog({ entityType, entityId, limit: 200 }),
    enabled: !!entityId
  })
}
